module.exports = __webpack_public_path__ + "img/API.936000a4.svg";